import { AboutLoanForm } from "@/features/purpose/use-about-loan-form";
import { DeepUndefined } from "@/types/util-types";

export const defaultAboutLoanForm: DeepUndefined<AboutLoanForm> = {
	appliedAmount: 200000,
	refinanceAmount: 0,
	appliedRepaymentTime: 10 * 12,
	isAffirmedRefinanceLoan: undefined,
	purpose: undefined,
};
